//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchManagerMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchManagerMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchManagerMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
         console.log('handleCreationComplete', this._bridge.getRouteParam('id'))
        const teamId = this._bridge.getRouteParam('id')
        const matchGroupId = this._bridge.getRouteQuery('matchGroupId')
        this.creationComplete({
            parameters: {id: teamId, matchId: matchGroupId, order: 1}
        })
    },
    handleDataLoaded: function() {
        this.target().teamManager.team.matchId = this._bridge.getRouteQuery('matchId')
    },
    handleRemoveService: function(e) {
        console.log('remove the player in the team manage', e)
        // remove the player in the target
        const playerId = e.data.options.data.id
        const playerList = this.target().teamManager.playerList
        for (let i = 0; i < playerList.length; i++) {
            let player = playerList[i]
            if (player.id == playerId) {
                playerList.splice(i, 1)
                return
            }
        }
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchManagerMediator, BaseMediator);

module.exports = tbs_controller_MatchManagerMediator